import { ToastContainer } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import { getUf } from "../../services/apiUf";
import { useNavigate, useParams } from "react-router-dom";
import { getCidade } from "../../services/apiCidade";
import SelectGenerico from "../../components/selectGenerico/selectGenerico";
import InputGenerico from "../../components/inputGenerico/inputGenerico";
import { Helmet } from "react-helmet";

export default function VisualizarCidade() {
  const { cdCidade } = useParams();
  const [cidade, setCidade] = useState<{ cdUf: number; nmCidade: string }>();
  const navigate = useNavigate();
  const selectRef = useRef<HTMLSelectElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [uf, setUf] = useState<{
    nmSigla: string;
    cdUf: number;
    nmUf: string;
  }>();
  const fetchCidade = async (cd: any) => {
    try {
      const response = await getCidade(cd);
      setCidade(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchUf = async () => {
    try {
      if (cidade) {
        const response = await getUf(cidade.cdUf);
        setUf(response.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleVoltar = () => {
    navigate(`/milshop/cidade/consultar`);
  };

  useEffect(() => {
    fetchCidade(cdCidade);
  }, [cdCidade]);
  useEffect(() => {
    fetchUf();
  }, [cidade]);

  return (
    <>
      <Helmet>
        <title>Visualizar cidade</title>
      </Helmet>
      <div className="container mt-5">
        <div className="row justify-content-center ">
          <div className="col-md-6 bg-light rounded shadow p-4">
            <form className="mb-3">
              {uf && (
                <SelectGenerico
                  opcao={{
                    valor: uf.cdUf,
                    rotulo: `(${uf.nmSigla}) ${uf.nmUf}`,
                  }}
                  label="Estado"
                  mensagemError="Estado não encontrado."
                  opcaoPadrao={`(${uf.nmSigla}) ${uf.nmUf}`}
                  classe={`selectUf form-select mb-3 `}
                  disabled={true}
                  classPadrao="corOption"
                  valorSelecionado={uf.cdUf} 
                  ref={selectRef}
                />
              )}
              {cidade && (
                <InputGenerico
                  name="nomeCidade"
                  value={cidade.nmCidade}
                  label="Nome da Cidade"
                  placeholder="Digite aqui..."
                  className={`form-control `}
                  disabled={true}
                  ref={inputRef}
                  type="text"
                />
              )}
              <div className="d-flex mt-4">
                <a
                  className="btn btn-outline-warning me-2 btn-sm"
                  role="button"
                  style={{ width: "100px" }}
                  onClick={handleVoltar}
                >
                  Voltar
                </a>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer />
      </div>
    </>
  );
}
